import {circularProgressClasses, styled} from "@mui/material";
import * as React from "react";
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import TopBar from "../../../components/TopBarV2";
import StepperProjectSetup from "../../../components/stepper-ps";
import Container from "@mui/material/Container/Container";
import firebase from "../../../firebase/firebase";

import {useNavigate, useParams } from 'react-router-dom'

import {AuthUserContext} from "../../../providers/AuthProvider";
import Stack from "@mui/material/Stack/Stack";
import Typography from "@mui/material/Typography/Typography";
import Box from "@mui/material/Box/Box";
import TextField from "@mui/material/TextField/TextField";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import Button from "@mui/material/Button/Button";
import { CheckCircle } from "@mui/icons-material";
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import Fab from "@mui/material/Fab/Fab";
import ScrollToTop from "../../../utils/scrollTop";
function StepThreeFinancials() {
  let { projectId } = useParams();
  const storageRef = firebase.storage().ref();
  const { user, profile } = React.useContext(AuthUserContext);
  const navigator = useNavigate();
  const [type, setType] = React.useState();
  const [files, setFiles] = React.useState();
  const Input = styled('input')({
    display: 'none',
  })
  const setFile = (e) => {
     
    const list= files ? [...files] : [];

    list.push({file: e.target.files[0], progress: 0, type});
    setFiles(list);
  }
  const uploadFile =  () => {
    files.forEach((file, i) => {
      if (file.progress === 0) {
        const path = `projects/${user?.uid}/${file.file.name}`
        const uploadTask = storageRef.child(path).put(file.file);
        uploadTask.on('state_changed',
          (snapshot) => {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            const newState = files;
            newState[i].progress = progress
            setFiles([...newState])
            console.log('Upload is ' + progress + '% done');
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                console.log('Upload is paused');
                break;
              case firebase.storage.TaskState.RUNNING: // or 'running'
                console.log('Upload is running');
                break;
            }
          },
          (error) => {
          },
          () => {
            const newState = files;
            newState[i].progress = 100
            newState[i].url = path
            setFiles([...newState])
            // Handle successful uploads on complete
            // For instance, get the download URL: https://firebasestorage.googleapis.com/...

          }
        );
      } else {
        return file
      }
    })

  }

  const next = async () => {
     
    console.log(`Step three form data post`);
    const projectRef = firebase.firestore().collection('projects').doc(projectId);
    const objUpdate = {
      financial: files.map((d) => {return {url: d.url, type: d.type}}),
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    }
    await projectRef.update(objUpdate)
    navigator(`/creator/projects/add/step/4/${projectId}`)
  }

  return (
    <React.Fragment>
      	<ScrollToTop/>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
      {/* Hero unit */}
      {/*<TopBar showBar={true}/>*/}
      <StepperProjectSetup stepNumber={3}/>
      <Container maxWidth="md" sx={{ py:5}}>
        <Stack direction={'column'} justifyContent="flex-start"  spacing={5} sx={{width: '100%'}}>
          <Typography variant="h4" align="left" color="text.primary" component="p">
            Upload financial documents
          </Typography>
          <Typography variant="body1" align="left" color="text.primary" component="p" sx={{ lineHeight:2}}>
            For this step you will need the <font color="#204488">following documents:</font>
            <ul style={{
              listStyle: 'inside'
            }}>
              <li>
                Production budget analysis
              </li>
              <li>
                Marketing budget analysis
              </li>
              <li>
                Distribution plan
              </li>
              <li>
                Timeframe (Roi)
              </li>
              <li>
                Projected Income
              </li>
            </ul>
          </Typography>

          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
          >
            <TextField fullWidth variant={'outlined'} select onChange={(e) => setType(e.target.value)} label={'Select document type'} sx={{textAlign: 'left'}}>
              <MenuItem value={'Production budget analysis'}>
                Production budget analysis
              </MenuItem>
              <MenuItem value={'Marketing budget analysis'}>
                Marketing budget analysis
              </MenuItem>
              <MenuItem value={'Distribution plan'}>
                Distribution plan
              </MenuItem>
              <MenuItem value={'Timeframe (Roi)'}>
                Timeframe (Roi)
              </MenuItem>
              <MenuItem value={'Projected Income'}>
                Projected Income
              </MenuItem>
            </TextField>
            <label htmlFor="document-upload">
              <Input accept="**/*" id="document-upload" multiple={false} type="file" onChange={setFile} />
              <Button component="span" variant={'outlined'} color={'primary'} startIcon={<AddIcon />} sx={{minWidth: 150, paddingY: '15px', borderRadius:0}} size={'small'}>
                Choose file
              </Button>
            </label>


            <Button variant={'contained'} color={'primary'} sx={{minWidth: 150, paddingY: '15px', borderRadius:0}} size={'small'} onClick={uploadFile}>
              Upload
            </Button>
          </Stack>
          <Container maxWidth="md" component="main" sx={{ mt: 5}}>
            {files && files.length > 0 && files.reverse().map((d, i) =>
              (<Stack key={i}
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={2}
                      sx={{borderBottom: '1px solid #ccc', paddingY:2}}
              >

                <Stack
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  spacing={2}
                  sx={{flex:1}}
                >
                  {d.progress > 0 && d.progress < 100 ?
                    <CircularProgress
                      variant="indeterminate"
                      disableShrink
                      sx={{
                        color: (theme) => (theme.palette.mode === 'light' ? '#b9b9bc' : '#909093'),
                        animationDuration: '550ms',
                        left: 0,
                        [`& .${circularProgressClasses.circle}`]: {
                          strokeLinecap: 'round',
                        },
                      }}
                      size={30}
                      thickness={4}
                    />
                    :
                    <>
                    {d.progress === 100 && <CheckCircle color={"primary"} style={{ height: 20, width: 20}}/>}
                    {(!d.progress) && 
                                    <img
                                    src="/assets/icons/file-upload.png"
                                    style={{ height: 20, width: 20 }}
                                    alt=""
                                    />
                                  }
                    </>
                  }

                  <Typography color={d.progress > 0 && d.progress < 100  ? '':'secondary'}>
                    {d.file.name}
                  </Typography>


                </Stack>
                <Box   sx={{ paddingX:2 , borderRight: '1px solid #ccc' }}>

                  <Box   sx={{ p: 1, background:'#F1EFEF', fontSize:'small', color:'#848484'}}>
                    {(d.file.size/1024/1024).toFixed(0) == 0 ? (d.file.size/1024).toFixed(0) + ' KB' :(d.file.size/1024/1024).toFixed(0) + ' MB'}
                  </Box>
                </Box>
                <Fab  sx={{backgroundColor: '#F1EFEF', color:'#848484', boxShadow:'none'}} size={'small'} aria-label="delete" onClick={() => {
                  setFiles([
                    ...files.slice(0, i),
                    ...files.slice(i + 1, files.length)
                  ]);
                }}>
                  <ClearIcon />
                </Fab>
              </Stack>)
            )}


          </Container>
          <Stack spacing={2} direction="row" sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            {/* <Button  sx={{pt: 1.2, pb:1.2, pl: 5, pr:5,  textDecoration:'underline'}}  >Save as Draft</Button> */}

            <Button variant="contained" sx={{pt: 1.2, pb:1.2, pl: 5, pr:5,}}  onClick={next}>Next</Button>
          </Stack>

        </Stack>
      </Container>
    </React.Fragment>
  )
}
export  default StepThreeFinancials